import axios from 'axios';
import { PLATFORM_TYPE } from './constants';

// use only for image upload
const api = axios?.create({
  baseURL: process.env?.REACT_APP_SERVER_REST_URL,
  headers: {
    'x-from-web': 'true',
    'x-platform-type': PLATFORM_TYPE,
  },
});

export default api;
